import { configureStore } from "@reduxjs/toolkit";
import siteSettings from "./Reducers/SiteSettingsSlice";
import mainNavigation from "./Reducers/MainNavigationSlice";

export const store = configureStore({
    reducer: {
        siteSettings: siteSettings,
        navigation: mainNavigation,
    }
});